import { useRef, useCallback } from 'react';
import { MenuItemWrapper, MenuItemButton, MenuItemButtonArrow, MenuItemContent, MenuItemContentHeader, MenuItemCloseButton, MenuItemBackArrow, MenuItemHeading } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ICON_UI_ARROW_RIGHT } from '../../icons/ICON_UI_ARROW_RIGHT.js';
import { ICON_UI_CHEVRON_RIGHT } from '../../icons/ICON_UI_CHEVRON_RIGHT.js';

var PopoutMenuItem = function PopoutMenuItem(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    id = _ref.id,
    title = _ref.title,
    _ref$activeItemId = _ref.activeItemId,
    activeItemId = _ref$activeItemId === void 0 ? null : _ref$activeItemId,
    _ref$hiddenOnMobile = _ref.hiddenOnMobile,
    hiddenOnMobile = _ref$hiddenOnMobile === void 0 ? false : _ref$hiddenOnMobile,
    onToggle = _ref.onToggle,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$alignContentToIt = _ref.alignContentToItem,
    alignContentToItem = _ref$alignContentToIt === void 0 ? false : _ref$alignContentToIt;
  var active = activeItemId === id;
  var expandButtonRef = useRef(null);
  var contentContainerID = "menu-item-content_".concat(id);
  var handleToggleActive = useCallback(function () {
    var idToToggle = active ? null : id;
    onToggle(idToToggle);
  }, [active, id, onToggle]);
  return /*#__PURE__*/jsxs(MenuItemWrapper, {
    className: className
    // @ts-ignore
    ,
    $active: active,
    $hidden: hiddenOnMobile,
    $hasChildren: children,
    $alignContentToItem: alignContentToItem,
    children: [/*#__PURE__*/jsxs(MenuItemButton, {
      type: "button",
      onClick: handleToggleActive,
      "aria-controls": contentContainerID,
      "aria-expanded": active,
      ref: expandButtonRef
      // @ts-ignore
      ,
      $active: active && children,
      children: [title, children && /*#__PURE__*/jsx(MenuItemButtonArrow, {
        path: ICON_UI_CHEVRON_RIGHT,
        size: "xxs",
        sizeMobile: "xxs",
        "aria-hidden": "true",
        $active: active
      })]
    }), active && children && /*#__PURE__*/jsxs(MenuItemContent, {
      id: contentContainerID
      // @ts-ignore
      ,
      $active: active,
      children: [/*#__PURE__*/jsxs(MenuItemContentHeader, {
        children: [/*#__PURE__*/jsx(MenuItemCloseButton, {
          type: "button",
          "aria-label": "Close",
          lang: "en",
          onClick: handleToggleActive,
          children: /*#__PURE__*/jsx(MenuItemBackArrow, {
            path: ICON_UI_ARROW_RIGHT,
            size: "xxs",
            sizeMobile: "xxs",
            "aria-hidden": "true"
          })
        }), /*#__PURE__*/jsx(MenuItemHeading, {
          children: title
        })]
      }), children]
    })]
  });
};
var PopoutMenuItem$1 = PopoutMenuItem;

export { PopoutMenuItem$1 as default };
//# sourceMappingURL=PopoutMenuItem.js.map
